import React from "react";
import { icon_notice_n } from "styles/img";
import { hanaWebviewExit } from "../../lib/utils";

const CertificationError = (props) => {
  const searchParam = new URLSearchParams(props.location.search);
  const reason = searchParam.get("reason") || "";


  return (
    <div className="hana_wrap">
      {/*         
      <div className="intro_top">
        <div className="intro_top_view">
          <h1>서비스 이용하기</h1>
          <a href="javascript:;" className="top_close_btn">
            이전
          </a>
        </div>
      </div> */}

      <div className="hana_intro err_intro">
        <div className="img_wrap">
          <img src={icon_notice_n} alt="에러" className="tit3" />
          {/* <p className="intro_tt">{reason}</p> */}

          <p className="intro_tt">
            {reason.split("<br/>").map((line) => {
              return (
                <React.Fragment key={line}>
                  {line}
                  <br />
                </React.Fragment>
              );
            })}
          </p>
        </div>
      </div>

      <div className="btn_area fixed apply_btn">
        <div className="bt_col1">
          <input
            type="button"
            value="하나머니 돌아가기"
            className="navy pop"
            onClick={hanaWebviewExit}
          />
        </div>
      </div>
    </div>
  );
};

export default CertificationError;
